import { authService } from '../index';
import { httpPostAsync } from '../utils/HttpClient';
import { saveFile } from '../utils/utils';
import { IConfiguration } from './ConfigurationData';

/**
 * Downloads a deposit's receipt: the client's down payment receipt report (DownPaymentReceipt.trdp unless configured)
 * for one ApplicationDownPaymentResponse. The Down Payments list and the Down Payment dialog's result both print it.
 */
export const viewDownPaymentReceiptReportAsync = async (configuration: IConfiguration | undefined, id: string) => {
  const bearerToken = await authService.getToken();

  const reportName = configuration?.downPaymentReceiptReport
    ? configuration.downPaymentReceiptReport
    : 'DownPaymentReceipt.trdp';

  const report = await httpPostAsync(`api/reporting/getReport`,
    {
      reportName: reportName,
      reportParameters: [{
        name: "DownPaymentResponseId",
        value: id,
      }],
      reportFormat: "1"
    }, bearerToken!);

  saveFile(report!, 'report.pdf');
};
